<template>
  <div id="pageContent" class="privacy-page">
    <div class="header">
      <img src="@/assets/img/dragons_logo.png" class="dragons-logo" alt="dragons_logo"><br>
      <img src="@/assets/img/logo_text.png" class="logo-text" alt="logo_text">
      <p>서비스 이용약관</p>
    </div>

    <div v-if="anchors" class="policy-anchor">
      <div v-for="(a, i) in anchors"
           :key="i"
           class="anchor">
        <a href="javascript:void(0)" @click="goAnchor(a.anchor)">
          <i>{{Number(a.id) + 1}}</i>
          {{a.name}}
        </a>
      </div>
    </div>

    <div v-if="content" v-html="content" style="padding-bottom: 100px"></div>
  </div>
</template>

<script>
import privacy from './Policy/index'
export default {
  name: 'ServicePolicy',
  watch: {
    $route (to, from) {
      if (to.name === from.name && to.params.version !== from.params.version) {
        const ver = to.params.version
        this.init()
        this.setHistory()
        this.setContent(ver)
      }
    }
  },
  data() {
    return {
      version: 'latest',
      history: null,
      content: null,
      anchors: []
    }
  },
  mounted () {
    const ver = this.$route.params.version || 'latest';
    this.init()
    this.$nextTick(() => {
      this.setHistory()
      this.setContent(ver)
    })
  },
  methods: {
    init () {
      if (this.$route.hash) {
        this.$router.replace({ hash: '' })
      }
      this.history = null
      this.content = null
      this.anchors = []
    },
    setHistory () {
      this.history = Object.keys(privacy).map(x => {
        const data = privacy[x]
        return {
          version: x,
          name: data.name
        }
      }).sort((a, b) => a.version.toLowerCase() < b.version.toLowerCase() ? 1 : -1)
    },
    setContent (ver) {
      const data = privacy[ver]
      const html = data && data.html || null // html 데이터가 있으면 여기서 렌더
      const link = data && data.link || null // link 데이터가 있으면 아웃링크로 이동
      if (!ver) {
        ver = 'latest'
      }
      this.version = ver
      if (!this.version || this.version !== ver) {
        this.setRouter(ver)
      }
      if (html) {
        const el = document.createElement('div')
        el.innerHTML = html
        // data-index 속성 검사하여 북마크 생성
        if (el.querySelectorAll('[data-index]') && el.querySelectorAll('[data-index]').length > 0) {
          el.querySelectorAll('[data-index]').forEach((x, i) => {
            this.anchors.push({
              id: x.dataset.index,
              name: x.dataset.label || x.textContent,
              anchor: `anchor_${i}_${x.dataset.index}`
            })
            x.setAttribute('id', `anchor_${i}_${x.dataset.index}`)
          })
        }
        this.content = el.innerHTML
      } else if (link) {
        window.open(link)
      } else {
        alert('올바른 정보를 불러오지 못했습니다. 메인페이지로 이동합니다.')
        this.$router.push('/')
      }
    },
    setRouter (ver) {
      const data = privacy[ver]
      const html = data && data.html || null // html 데이터가 있으면 여기서 렌더
      const link = data && data.link || null // link 데이터가 있으면 아웃링크로 이동
      if (html) {
        this.$router.push({
          params: {
            version: ver
          }
        })
      } else if (link) {
        window.open(link)
      }
    },
    goAnchor (pos) { // 앵커 타겟이 헤더에 묻혀 헤더높이 + 일정수치만큼 스크롤 내림
      const headerHeight = window.innerWidth >= 768 ? 80 : 60
      const plusHeight = window.innerWidth >= 768 ? 280 : 130
      const position = document.getElementById(pos).offsetTop-headerHeight; //  + plusHeight + headerHeight
      window.scrollTo(0, position)
    }
  }
}
</script>
